<template>
  <section class="mobileList">
    <div class="header">
      <a href="javascript:;"
         @click="$router.back(-1)">
        <van-icon name="arrow-left"
                  class="header-left" />
      </a>
      产品列表
    </div>
    <van-list v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
      <Product :products="list" />
    </van-list>
    <div class="zhimabgm"
         @click="onZhima"
         v-if="endtime<20190820105406498"></div>
  </section>
</template>

<script>
import { NowTimeCode } from "@/utils/index";

import Product from "@/components/Mobile/List/Product.vue";
export default {
  name: "Order",
  data () {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      size: 10,
      loading: false,
      finished: false,
      page: 0,
      list: [],
      endtime: NowTimeCode()

    };
  },
  components: {
    Product
  },
  mounted: function () {
    window.scroll(0, 0);

  },
  computed: {
    products () {
      return this.$store.state.product.products;
    }
  },
  methods: {
    fetchProductList () {
      let params = {
        size: this.size,
        page: this.page
      };
      this.$store.dispatch("product/fetchProductList", { params }).then(() => {
        this.list = this.list.concat(this.$store.state.product.products.data);
        if (this.$store.state.product.products.data.length == 0) {
          this.finished = true;
        }
        this.loading = false;

        console.log(this.list)

      });
    },
    onZhima () {
      let url = "https://cuxiao.m.suning.com/scms/wapdn03669.html?utm_source=pl-00005&utm_medium=hp-shs-bn-w1-m"
      window.location.href = url;
    },
    onLoad () {
      this.page++;
      this.fetchProductList();
    }
  },
  created () {
  }
};
</script>

<style>
.mobileList {
  background: #fff;
  padding: 0rem 0 1rem;
}
.mobileList .header {
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  position: relative;
  background: #fff;
}
.mobileList .header .header-left {
  position: absolute;
  left: 0.1rem;
  top: 0.23rem;
}
.zhimabgm {
  width: 0.76rem;
  height: 0.43rem;
  background: url(https://image.suhuishou.com/attached/image/20190813/20190813115001_17373.jpg)
    no-repeat;
  background-size: 100%;
  position: fixed;
  right: 0.05rem;
  bottom: 0.7rem;
}
</style>
